import getAttributionCategory from "./getAttributionCategory";
import getPageName from "./getPageName";
import getSiteContent2 from "./getSiteContent2";
import getPageType from "../common/getPageType";

const itemsTypeSharedBoard = state => ({
  ...state,
  globals: {
    ...state.globals,
    attributionCategory: getAttributionCategory(),
    pageName: getPageName(),
    pageType: getPageType(),
    siteContent2: getSiteContent2()
  }
});

export default itemsTypeSharedBoard;
